import {
  Component,
  OnInit,
  input,
  ViewEncapsulation,
  ChangeDetectorRef,
  OnDestroy,
  ChangeDetectionStrategy,
  signal,
  inject,
} from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import $ from 'jquery';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { TimersService } from '@_services/timers.service';
import { BehaviorService } from '@_services/Behavior.service';
import {
  Observable,
  Subject,
  takeUntil,
  switchMap,
  concatMap,
  filter,
  take,
  tap,
  of,
  from,
  EMPTY,
  toArray,
  catchError,
} from 'rxjs';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';
import { NgxCurrencyModule } from '@directives/currencymask/currency-mask.module';
import { CurrencyFormatModule } from '@directives/currencyformat/currency-format.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MaterialModule } from '@/app/Shared/material.module';

@Component({
  selector: 'app-re-calc-timeEntrie-dialoge',
  templateUrl: './re-calc-timeEntrie-dialoge.component.html',
  styleUrls: ['./re-calc-timeEntrie-dialoge.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgxCurrencyModule,
    MaterialModule,
    CurrencyFormatModule,
    CommonModule,
    FormsModule,
    DragDropModule,
    FlexLayoutModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ReCalcTimeEntriesDialogeComponent implements OnInit, OnDestroy {
  private _mainAPiServiceService = inject(MainAPiServiceService);
  private timersservice = inject(TimersService);
  private toastr = inject(ToastrService);
  private cd = inject(ChangeDetectorRef);
  public dialogRef = inject(MatDialogRef<ReCalcTimeEntriesDialogeComponent>);
  private behaviourService = inject(BehaviorService);
  private dialog = inject(MatDialog);

  /** Reference to the confirmation dialog instance, if currently open. */
  confirmDialogRef = signal<MatDialogRef<FuseConfirmDialogComponent> | null>(null);

  /** Form group provided by the parent component for time entry settings. */
  settingForm = input<FormGroup>();

  /** Stores error and warning details related to time entry operations. */
  errorWarningData = signal<any>(null);

  /** Stores data to be added or processed during the current operation. */
  addData = signal<any>([]);

  /** Stores the selected template name. */
  templateName = signal<any>(null);

  /** Stores the currently selected work-in-progress (WIP) entry. */
  getSelectedWIP = signal<any>(null);

  /** Stores the recalculated price details for the selected WIP entry. */
  getSelectedWIPNewPrice = signal<any>([]);

  /** Stores the UI state, including loading indicators and WIP data status. */
  uiState = signal({
    isLoadingResults: true,
    isspiner: false,
    isWipData: false,
  });

  /** Stores the success message displayed after updating a time entry. */
  successMsg = signal<any>('Time entry Updated Successfully');

  /** Stores the work item currently being processed. */
  workItem = signal<any>(null);

  /** Stores the current user's details retrieved from local storage. */
  currentUser = signal(JSON.parse(localStorage.getItem('currentUser') || '{}'));

  /** Stores the fee earner GUID, derived from the user's working-on-behalf GUID or user ID. */
  feeErner = signal<any>(
    this.currentUser()?.WORKINGONBEHALFOFGUID
      ? this.currentUser()?.WORKINGONBEHALFOFGUID
      : this.currentUser()?.UserId,
  );

  /** Tracks the total number of processed and matching work items. */
  count = signal({
    firstCount: 0,
    secondCount: 0,
  });

  /** Subject used to unsubscribe from active subscriptions when the component is destroyed. */
  private _unsubscribeAll$: Subject<void> = new Subject();

  ngOnInit() {
    localStorage.setItem('istrackid', 'ReCalcTimeEntriesDialogeComponent');
    this.behaviourService.workInProgress$
      .pipe(
        filter((result): result is NonNullable<typeof result> => !!result),
        takeUntil(this._unsubscribeAll$),
      )
      .subscribe((result) => {
        this.getSelectedWIP.set(result);
      });

    this.behaviourService.defultFeeErnerData$
      .pipe(
        filter((result): result is NonNullable<typeof result> => !!result),
        takeUntil(this._unsubscribeAll$),
      )
      .subscribe((result) => {
        this.feeErner.set(result);
      });

    this.behaviourService.APIretryCall$.pipe(
      filter(
        (result) =>
          localStorage.getItem('istrackid') === 'ReCalcTimeEntriesDialogeComponent' &&
          !!result?.['click'],
      ),
      takeUntil(this._unsubscribeAll$),
    ).subscribe((result) => {
      if (result['data']?.['CalcWorkItemCharge']) {
        this.loadData();
      } else if (result['data']?.['workitem']) {
        this.changePrice();
      }
    });

    let selectFreeearnar = JSON.parse(localStorage.getItem('Work_in_progress_filter') || '{}');
    this.feeErner.set(selectFreeearnar?.FEEEARNER);
    this.loadData();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * It runs only once after the component's view has been rendered.
   */
  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  /**
   * This function is used to load the data value.
   */
  loadData() {
    this.count.set({
      firstCount: 0,
      secondCount: 0,
    });
    this.uiState.update((s) => ({ ...s, isLoadingResults: true }));
    this.behaviourService.setnextReCalcTimeEntrie(null);

    let potData = {
      MatterGuid: this.getSelectedWIP()?.MATTERGUID,
      FEEEARNER: this.feeErner(),
      INVOICED: 'No',
      ITEMDATESTART: '',
      ITEMDATEEND: '',
    };
    this._mainAPiServiceService
      .getSetData({ Action: 'GetData', Filters: potData }, 'workitem')
      .pipe(
        switchMap((res) => {
          if (res?.CODE == 200 && res?.STATUS == 'success' && res?.DATA?.WORKITEMS?.length) {
            const validWorkItems = res.DATA.WORKITEMS.filter(
              (item: any) => item.QUANTITYTYPE != 'Fixed' && !item.ISGROUPBY && !item.INVOICEGUID,
            );

            if (!validWorkItems.length) {
              this.uiState.update((s) => ({ ...s, isWipData: false, isLoadingResults: false }));
              if (this.count().firstCount == this.count().secondCount) {
                this.dialogRef.close(true);
              } else {
                this.dialogRef.close(false);
              }
              $('#refreshWorkInprogress').click();
              return EMPTY;
            }

            return from(validWorkItems).pipe(
              concatMap((item: any) => this.processWorkItem(item)),
              toArray(),
              tap(() => {
                if (this.count().firstCount == this.count().secondCount) {
                  this.dialogRef.close(true);
                } else {
                  this.dialogRef.close(false);
                }
                $('#refreshWorkInprogress').click();
              }),
            );
          } else {
            this.uiState.update((s) => ({ ...s, isWipData: false, isLoadingResults: false }));
            return EMPTY;
          }
        }),
        takeUntil(this._unsubscribeAll$),
      )
      .subscribe({
        next: () => {},
        error: (err) => {
          this.uiState.update((s) => ({ ...s, isLoadingResults: false }));
          this.toastr.error(err);
        },
        complete: () => {
          this.uiState.update((s) => ({ ...s, isLoadingResults: false }));
        },
      });
  }

  /**
   * Process a single work item sequentially
   */
  private processWorkItem(item: any): Observable<any> {
    this.count.update((count) => ({
      ...count,
      firstCount: count.firstCount + 1,
    }));
    this.uiState.update((s) => ({ ...s, isLoadingResults: true, isWipData: true }));

    let currentItem = { ...item };
    if (currentItem.QUANTITYTYPE == 'hh:mm') {
      currentItem.QUANTITYTYPE = 'X';
    } else if (currentItem.QUANTITYTYPE == 'Hours') {
      currentItem.QUANTITYTYPE = 'H';
    } else if (currentItem.QUANTITYTYPE == 'Minutes') {
      currentItem.QUANTITYTYPE = 'M';
    } else if (currentItem.QUANTITYTYPE == 'Days') {
      currentItem.QUANTITYTYPE = 'D';
    } else if (currentItem.QUANTITYTYPE == 'Units') {
      currentItem.QUANTITYTYPE = 'U';
    } else if (currentItem.QUANTITYTYPE == 'Fixed') {
      currentItem.QUANTITYTYPE = 'F';
    } else {
      currentItem.QUANTITYTYPE = 'F';
    }
    this.workItem.set(currentItem);

    let sendData = {
      MATTERGUID: currentItem.MATTERGUID,
      FEEEARNER: currentItem.FEEEARNER,
      FEETYPE: currentItem.FEETYPE,
      QUANTITY: currentItem.QUANTITY,
      QUANTITYTYPE: currentItem.QUANTITYTYPE,
      RATEID: currentItem.RATEID,
    };

    let Payload = {
      Action: 'CalcWorkItemCharge',
      Data: {
        ...sendData,
      },
    };

    return this._mainAPiServiceService.getSetData(Payload, 'utility').pipe(
      switchMap((response) => {
        if (response?.CODE == 200 && response?.STATUS == 'success') {
          this.getSelectedWIPNewPrice.set(response.DATA);
          const newPrice = response.DATA;
          const current = this.workItem();

          if (
            current?.PRICE == newPrice?.PRICE &&
            current?.GST == newPrice?.GST &&
            current?.PRICEINCGST == newPrice?.PRICEINCGST
          ) {
            this.uiState.update((s) => ({ ...s, isWipData: false, isLoadingResults: false }));
            this.count.update((count) => ({
              ...count,
              secondCount: count.secondCount + 1,
            }));
            return of(true);
          }

          this.uiState.update((s) => ({ ...s, isLoadingResults: false, isWipData: true }));

          return this.behaviourService.nextReCalcTimeEntrie$.pipe(
            filter((res) => res == 'saveTimeEntry' || res == 'skipTimeEntry'),
            take(1),
            tap(() => {
              this.behaviourService.setnextReCalcTimeEntrie(null);
            }),
          );
        }

        this.uiState.update((s) => ({ ...s, isLoadingResults: false }));
        return of(false);
      }),
      catchError((err) => {
        this.uiState.update((s) => ({ ...s, isLoadingResults: false }));
        this.toastr.error(err);
        return of(false);
      }),
    );
  }

  /**
   * This function is used to change the price
   */
  changePrice() {
    this.uiState.update((s) => ({ ...s, isspiner: true }));
    const updatedWorkItem = {
      ...this.workItem(),
      PRICE: this.getSelectedWIPNewPrice()?.PRICE,
      GST: this.getSelectedWIPNewPrice()?.GST,
      PRICEINCGST: this.getSelectedWIPNewPrice()?.PRICEINCGST,
    };
    this.workItem.set(updatedWorkItem);
    let PostData: any = updatedWorkItem;
    this.successMsg.set('Time entry updated successfully');
    let PostTimeEntryData: any = {
      FormAction: 'update',
      VALIDATEONLY: true,
      Data: PostData,
    };
    this.timersservice
      .setWorkItems(PostTimeEntryData)
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (res) => {
          if (res.CODE == 200 && res.STATUS == 'success') {
            this.checkValidation(res.DATA.VALIDATIONS, PostTimeEntryData);
          } else if (res.CODE == 451 && res.STATUS == 'warning') {
            this.checkValidation(res.DATA.VALIDATIONS, PostTimeEntryData);
          } else if (res.CODE == 450 && res.STATUS == 'error') {
            this.checkValidation(res.DATA.VALIDATIONS, PostTimeEntryData);
          } else if (res.MESSAGE == 'Not logged in') {
            this.dialogRef.close(false);
          }
        },
        error: (err) => {
          this.uiState.update((s) => ({ ...s, isspiner: false }));
          this.toastr.error(err);
        },
      });
  }

  /**
   * This function is used to check the validation data
   */
  checkValidation(bodyData: any, PostTimeEntryData: any) {
    let errorData: any = [];
    let warningData: any = [];
    let tempError: any = [];
    let tempWarning: any = [];
    bodyData.forEach(function (value) {
      if (value.VALUEVALID == 'NO') {
        errorData.push(value.ERRORDESCRIPTION);
        tempError[value.FIELDNAME] = value;
      } else if (value.VALUEVALID == 'WARNING') {
        tempWarning[value.FIELDNAME] = value;
        warningData.push(value.ERRORDESCRIPTION);
      }
    });
    this.errorWarningData.set({ Error: tempError, warning: tempWarning });
    if (Object.keys(errorData).length != 0) {
      this.toastr.error(errorData);
      this.uiState.update((s) => ({ ...s, isspiner: false }));
    } else if (Object.keys(warningData).length != 0) {
      // this.toastr.warning(warningData);
      const dialogRef = this.dialog.open(FuseConfirmDialogComponent, {
        disableClose: true,
        width: DIALOG_WIDTH.FULL,
        data: warningData,
      });
      this.confirmDialogRef.set(dialogRef);
      dialogRef.componentInstance.confirmMessage = 'Are you sure you want to Save?';
      dialogRef
        .afterClosed()
        .pipe(
          tap((result) => {
            this.confirmDialogRef.set(null);
            if (!result) {
              this.uiState.update((s) => ({ ...s, isspiner: false }));
            }
          }),
          filter((result) => !!result),
          tap(() => {
            this.uiState.update((s) => ({ ...s, isspiner: true }));
          }),
          switchMap(() => {
            PostTimeEntryData.VALIDATEONLY = false;
            return this.timersservice
              .setWorkItems(PostTimeEntryData)
              .pipe(takeUntil(this._unsubscribeAll$));
          }),
          takeUntil(this._unsubscribeAll$),
        )
        .subscribe({
          next: (res) => this.handleSaveResponse(res),
          error: (err) => {
            this.uiState.update((s) => ({ ...s, isspiner: false }));
            this.toastr.error(err);
          },
        });
    } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
      this.saveTimeEntry(PostTimeEntryData);
    }
  }

  /**
   * This function is used to save the time entry data value.
   */
  saveTimeEntry(PostTimeEntryData: any) {
    PostTimeEntryData.VALIDATEONLY = false;
    this.timersservice
      .setWorkItems(PostTimeEntryData)
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (res) => this.handleSaveResponse(res),
        error: (err) => {
          this.uiState.update((s) => ({ ...s, isspiner: false }));
          this.toastr.error(err);
        },
      });
  }

  /**
   * Shared handler for save response
   */
  private handleSaveResponse(res: any) {
    if (res?.CODE == 200 && res?.STATUS == 'success') {
      this.toastr.success(this.successMsg());
      this.behaviourService.setnextReCalcTimeEntrie('saveTimeEntry');
      this.uiState.update((s) => ({ ...s, isspiner: false }));
    } else if (res?.CODE == 451 && res?.STATUS == 'warning') {
      this.toastr.warning(res.MESSAGE);
      this.uiState.update((s) => ({ ...s, isspiner: false }));
    } else if (res?.CODE == 450 && res?.STATUS == 'error') {
      this.toastr.warning(res.MESSAGE);
      this.uiState.update((s) => ({ ...s, isspiner: false }));
    } else if (res?.MESSAGE == 'Not logged in') {
      this.dialogRef.close(false);
    }
  }

  /**
   * This function is used to SkipTime Entry.
   */
  skipTimeEntry() {
    this.behaviourService.setnextReCalcTimeEntrie('skipTimeEntry');
  }
}
